import { useState, type ReactNode } from 'react'
import { useDeviceGate } from '../../state/device'
import { Icon } from '../../components/Icon'
import { ConfirmDialog } from '../../components/ConfirmDialog'
import { signOut } from '../settings/signOut'
import { DeviceCode } from './DeviceCode'

/** Shared card for the waiting and blocked screens (same look as the sign-in screen). */
export function DeviceGateLayout({
  icon,
  title,
  tone,
  children,
  actions,
}: {
  icon: 'lock' | 'alert' | 'device'
  title: string
  tone: 'waiting' | 'blocked'
  children: ReactNode
  actions?: ReactNode
}) {
  const device = useDeviceGate((s) => s.device)
  const helpText = useDeviceGate((s) => s.helpText)
  const error = useDeviceGate((s) => s.error)
  const [confirmSignOut, setConfirmSignOut] = useState(false)

  return (
    <main className={`sign-in device-gate device-gate-${tone}`}>
      <div className="sign-in-card">
        <span className="device-gate-icon" aria-hidden="true">
          <Icon name={icon} />
        </span>
        <h1 className="device-gate-title">{title}</h1>
        <div className="device-gate-copy">{children}</div>
        <DeviceCode code={device.code} />
        {device.name ? (
          <p className="device-gate-name">
            <Icon name="device" />
            <span>{device.name}</span>
          </p>
        ) : null}
        {helpText ? (
          <p className="notice device-gate-help" role="note">
            {helpText}
          </p>
        ) : null}
        {error ? (
          <p className="notice error" role="alert">
            {error}
          </p>
        ) : null}
        <div className="device-gate-actions">
          {actions}
          <button type="button" className="button" onClick={() => setConfirmSignOut(true)}>
            <Icon name="logout" />
            Sign out
          </button>
        </div>
      </div>
      <ConfirmDialog open={confirmSignOut} title="Sign out?" confirmLabel="Sign out" danger onClose={() => setConfirmSignOut(false)} onConfirm={signOut}>
        <p>You can sign in again later. This device keeps its approval request.</p>
      </ConfirmDialog>
    </main>
  )
}
